<template>
  <div class="point_transfer_container" v-if="transferBlocks.length">
    <AppPointTransferBlock
      v-for="(value, index) in transferBlocks"
      :auth_hash="value.auth_hash"
      :transferPoints="value.points"
      :quest="value.quest"
      :texts="remoteConfig && remoteConfig.transfer[value.type]"
      :key="index"
      :type="value.type"
    />
    <AppPointTransferBlock
      v-for="(value, index) in charityBlocks"
      :auth_hash="value.auth_hash"
      :transferPoints="value.points"
      :quest="value.quest"
      :texts="remoteConfig && remoteConfig.transfer[value.type + '_charity']"
      :key="index + '_charity'"
      :type="value.type"
      :isCharity="true"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CONFIG from "../../config";
import { directive as onClickaway } from "vue-clickaway2";
import AppPointTransferBlock from "./AppPointTransferBlock";

export default {
  name: "AppPointTransfer",
  components: {
    AppPointTransferBlock,
  },
  computed: {
    ...mapGetters(["remoteConfig", "p2pConfig", "currentUser"]),
    transferBlocks() {
      return Object.values(this.p2pConfig)
        .filter((v) => v.auth_hash && v.quest && v.quest.id)
        .sort((a, b) => (a.type > b.type ? 1 : -1));
    },
    charityBlocks() {
      return []; // Remove to enable charity P2P blocks
      return this.transferBlocks.filter((block) =>
        this.remoteConfig["p2pCharityWallets"].includes(block.type)
      );
    },
  },
};
</script>